<template>
  <p>finish onboarding</p>
</template>

<script>
export default {

}
</script>

<style>

</style>